import React from 'react';
import { IconButton, Icon, Typography, Box, useTheme } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

const HotelCardImageList = ({
  hotel,
  hasIdFav,
  isLoadImage,
  setIsLoadImage,
  getFavConfig,
  handleImageError,
  defaultImage,
  onClickDeleteFavorite,
  onClickAddFavorite,
  onClickOmit,
  isAdmin,
  isFromMap = false,
}) => {
  const theme = useTheme();

  const favConfig = getFavConfig(hotel.id_fav_message);

  const handleToggleFavorite = e => {
    e.stopPropagation();
    if (hasIdFav) {
      onClickDeleteFavorite();
    } else {
      onClickAddFavorite();
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        borderRadius: '8px 8px 0 0',
        position: 'relative',
        flexGrow: 1,
        minHeight: 0,
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: { xs: isFromMap ? 112 : 160, sm: isFromMap ? 112 : 144 },
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <img
          src={hotel.main_image || defaultImage}
          onError={e => handleImageError(e, hotel.main_image)}
          onLoad={() => setIsLoadImage(true)}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center 10%',
            borderRadius: '8px 8px 0 0',
            display: isLoadImage ? 'block' : 'none',
          }}
          alt={hotel.name}
        />

        {/* Fav text */}
        {hasIdFav && hotel.id_fav_message && favConfig && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              display: 'flex',
              alignItems: 'center',
              p: '4px 8px',
              borderRadius: '8px 0 0 0',
              zIndex: 11,
              backgroundColor: favConfig.color,
            }}
          >
            <Icon fontSize="small" sx={{ ml: 0.5 }}>
              {favConfig.icon}
            </Icon>
            <Typography
              sx={{
                ml: 0.5,
                color: '#000',
                fontSize: { xs: 14, sm: 16 },
                fontWeight: 500,
              }}
            >
              {favConfig.message}
            </Typography>
          </Box>
        )}

        {/* Favorite Heart */}
        {isAdmin && (
          <IconButton
            onClick={handleToggleFavorite}
            sx={{
              position: 'absolute',
              top: 4,
              right: 4,
              zIndex: 12,
              bgcolor: 'rgba(255,255,255,0.7)',
              '&:hover': { bgcolor: 'rgba(255,255,255,1)' },
              p: 0.5,
              borderRadius: '50%',
            }}
          >
            {hasIdFav ? (
              <FavoriteIcon sx={{ color: 'red' }} />
            ) : (
              <FavoriteBorderIcon sx={{ color: 'red' }} />
            )}
          </IconButton>
        )}

        {/* Trash Icon */}
        {isAdmin && (
          <IconButton
            onClick={e => {
              e.stopPropagation();
              onClickOmit();
            }}
            sx={{
              position: 'absolute',
              top: 45,
              right: 4,
              bgcolor: 'rgba(255,255,255,0.7)',
              '&:hover': { bgcolor: 'rgba(255,255,255,1)' },
              p: 0.5,
              borderRadius: '50%',
            }}
          >
            <DeleteIcon sx={{ color: theme?.tertiary }} />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default HotelCardImageList;
